import React, { useEffect, useState } from "react";
import { createThread, getEmployees } from "../../../api/serviceRecordApi";
import { useNavigate } from "react-router-dom";

const CreateThread = () => {
    const navigate = useNavigate();

    const [employees, setEmployees] = useState([]);
    const [employeeId, setEmployeeId] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [authorizedBy, setAuthorizedBy] = useState("");
    const [attachment, setAttachment] = useState(null);

    useEffect(() => {
        fetchEmployees();
    }, []);

    const fetchEmployees = async () => {
        const res = await getEmployees();
        setEmployees(res.data.data);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        formData.append("employeeId", employeeId);
        formData.append("subject", subject);
        formData.append("message", message);
        formData.append("authorizedBy", authorizedBy);

        if (attachment) {
            formData.append("attachment", attachment);
        }

        const res = await createThread(formData);

        if (res.data.success) {
            navigate(`/service-record`);
        }
    };

    return (
        <div className="container mt-4">
            <h4>Create Service Record</h4>

            <form onSubmit={handleSubmit}>

                {/* Employee Dropdown */}
                <div className="mb-3">
                    <label>Employee</label>
                    <select
                        className="form-control"
                        value={employeeId}
                        onChange={(e) => setEmployeeId(e.target.value)}
                        required
                    >
                        <option value="">-- Select Employee --</option>

                        {employees.map(emp => (
                            <option key={emp.intUserId} value={emp.intUserId}>
                                {emp.vchFullName}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Authorized By Dropdown */}
                <div className="mb-3">
                    <label>Authorized By</label>
                    <select
                        className="form-control"
                        value={authorizedBy}
                        onChange={(e) => setAuthorizedBy(e.target.value)}
                        required
                    >
                        <option value="">-- Select Authority --</option>
                        <option value="MD">Managing Director (MD)</option>
                        <option value="GM">General Manager (GM)</option>
                    </select>
                </div>

                {/* Subject */}
                <div className="mb-3">
                    <label>Subject</label>
                    <input
                        className="form-control"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        maxLength={40}
                        required
                    />
                    <div className="text-muted small">
                        {subject.length}/40 characters
                    </div>
                </div>

                {/* Message */}
                <div className="mb-3">
                    <label>Message</label>
                    <textarea
                        className="form-control"
                        rows="4"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        required
                    />
                </div>

                {/* Attachment */}
                <div className="mb-3">
                    <label>Attachment (optional)</label>
                    <input
                        type="file"
                        className="form-control"
                        onChange={(e) => setAttachment(e.target.files[0])}
                    />
                </div>

                <button className="btn btn-primary">
                    Create Thread
                </button>

            </form>
        </div>
    );
};

export default CreateThread;